<template>
    <modal :title="dialogTitle" :visible.sync="isShowDialog" width="600px" :close-on-click-modal="false">
        <el-form ref="form" label-width="140px" :rules="rules" :model="dioForm" @submit.native.prevent>
            <!-- Enterprise create: Company ID text input -->
            <el-form-item v-if="!isPersonal && !isEdit" :label="$t('account_redesign.company_id')" prop="companyCode">
                <el-input v-model.trim="dioForm.companyCode" style="width: 300px" :placeholder="$t('account_redesign.company_id_placeholder')"></el-input>
            </el-form-item>
            <!-- Enterprise edit: Company ID (read-only) + Company dropdown -->
            <el-form-item v-if="!isPersonal && isEdit" :label="$t('account_redesign.company_id')">
                <el-input :value="displayCompanyCode" style="width: 300px" disabled></el-input>
            </el-form-item>
            <el-form-item v-if="!isPersonal && isEdit" :label="$t('account_redesign.company')" prop="customerId">
                <el-select v-model="dioForm.customerId" style="width:300px" filterable :placeholder="$t('public.please')">
                    <el-option
                        v-for="item in companyOptions"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('user.account')" prop="account">
                <el-input v-model.trim="dioForm.account" style="width: 300px" :disabled="isEdit"></el-input>
            </el-form-item>
            <el-form-item :label="$t('user.name')" prop="username">
                <el-input v-model.trim="dioForm.username" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('user.status')" prop="status">
                <el-select v-model="dioForm.status" style="width:300px">
                    <el-option v-for="item in statusArray.slice(1)" :key="item.value" :value="item.value" :label="$t(item.label)"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('account_redesign.mobile_phone')" prop="mobile">
                <el-input v-model.trim="dioForm.mobile" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.email')" prop="email">
                <el-input v-model.trim="dioForm.email" style="width: 300px"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('account_redesign.close') }}</el-button>
            <el-button type="primary" :loading="submitLoading" @click="handleSave">{{ $t('public.btn_apply') }}</el-button>
        </div>

        <!-- 成功创建浮动框 -->
        <modal
            :title="successDialogTitle"
            :visible.sync="showSuccessDialog"
            width="600px"
            :close-on-click-modal="false"
            append-to-body
        >
            <div class="success-dialog-body">
                <p class="success-body-text">{{ $t('account_redesign.success_create_body') }}</p>
                <p class="success-warning-text">{{ $t('account_redesign.success_create_warning') }}</p>
                <p class="success-choose-text">{{ $t('account_redesign.success_create_choose') }}</p>
                <p class="success-desc-text">{{ $t('account_redesign.success_create_csv_desc') }}</p>
                <p class="success-desc-text">{{ $t('account_redesign.success_create_show_desc') }}</p>
                <div v-if="passwordVisible" class="password-display">
                    <span class="password-label">{{ $t('account_redesign.csv_password') }}：</span>
                    <span class="password-value">{{ createdPassword }}</span>
                </div>
                <p class="success-security-text">{{ $t('account_redesign.success_create_security') }}</p>
                <p class="success-warning-text">{{ $t('account_redesign.success_create_48h_warning') }}</p>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="downloadCsv">{{ $t('account_redesign.download_csv_file') }}</el-button>
                <el-button type="primary" @click="togglePassword">{{ passwordVisible ? $t('account_redesign.hide_password') : $t('account_redesign.show_password') }}</el-button>
                <el-button type="primary" @click="closeSuccessDialog">{{ $t('account_redesign.close') }}</el-button>
            </div>
        </modal>
    </modal>
</template>

<script>
import { accountList } from '@/api/modules/userInfo.js';
import { createPersonalAccount, createEnterpriseRootAccount, checkCompany, updateAccountProfile } from '@/api/modules/account.js';

export default {
    props: ['isShow', 'statusArray', 'activeUserType', 'customerArray', 'editObj'],
    computed: {
        isPersonal() {
            return this.activeUserType === 'PERSONAL';
        },
        isEdit() {
            return !!this.editObj && !!this.editObj.id;
        },
        dialogTitle() {
            if (this.isPersonal) {
                return this.isEdit ? this.$t('account_redesign.edit_personal_account') : this.$t('account_redesign.new_personal_account');
            }
            return this.isEdit ? this.$t('account_redesign.edit_enterprise_account') : this.$t('account_redesign.new_enterprise_account');
        },
        successDialogTitle() {
            return this.isPersonal
                ? this.$t('account_redesign.create_personal_success')
                : this.$t('account_redesign.create_enterprise_success');
        },
        isShowDialog: {
            get() {
                return this.isShow;
            },
            set(val) {
                this.$emit('update:isShow', val);
            }
        },
        companyOptions() {
            return (this.customerArray || []).filter(item => item.value !== null && item.value !== '-1' && item.value !== '-2');
        },
        /** Enterprise 编辑时根据 customerId 查找 companyCode（只读展示） */
        displayCompanyCode() {
            if (!this.dioForm.customerId) return '';
            const found = (this.customerArray || []).find(c => c.value === this.dioForm.customerId);
            return found && found.code ? found.code : '';
        },
        rules() {
            const r = {
                username: [
                    { required: true, message: this.$t('validate.user_name_required'), trigger: 'blur' },
                    { max: 50, message: this.$t('validate.len_50'), trigger: 'blur' }
                ],
                account: [
                    { required: true, message: this.$t('validate.user_account_required'), trigger: 'blur' },
                    { max: 20, message: this.$t('validate.len_20'), trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: this.$t('validate.user_mobile_required'), trigger: 'blur' },
                    { max: 20, message: this.$t('validate.len_20'), trigger: 'blur' }
                ],
                email: [
                    { required: true, message: this.$t('validate.email_required'), trigger: 'blur' },
                    { max: 255, message: this.$t('validate.len_255'), trigger: 'blur' },
                    { type: 'email', message: this.$t('validate.email_format'), trigger: ['blur', 'change'] }
                ],
                status: [{ required: true, message: this.$t('validate.user_status_required'), trigger: 'change' }]
            };
            if (!this.isPersonal) {
                if (this.isEdit) {
                    r.customerId = [{ required: true, message: this.$t('account_redesign.company_required'), trigger: 'change' }];
                } else {
                    r.companyCode = [{ required: true, message: this.$t('account_redesign.company_id_required'), trigger: 'blur' }];
                }
            }
            return r;
        }
    },
    watch: {
        isShow(val) {
            if (val) {
                this.resetForm();
            }
        }
    },
    data() {
        return {
            submitLoading: false,
            dioForm: {
                username: '',
                account: '',
                mobile: '',
                email: '',
                status: 1,
                customerId: '',
                companyCode: '',
                userType: ''
            },
            // 成功提示框
            showSuccessDialog: false,
            createdPassword: '',
            createdAccount: '',
            passwordVisible: false,
            // 企业创建成功后的 Company ID（用于 CSV 登录 URL）
            createdCompanyCode: ''
        };
    },
    methods: {
        resetForm() {
            if (this.editObj && this.editObj.id) {
                // 兼容 snake_case（后端 @SnakeCaseResponse 返回 customer_id）和 camelCase
                const customerId = this.editObj.customerId || '';
                this.dioForm = {
                    id: this.editObj.id,
                    username: this.editObj.username || '',
                    account: this.editObj.account || '',
                    mobile: this.editObj.mobile || '',
                    email: this.editObj.email || '',
                    status: this.editObj.status !== undefined ? this.editObj.status : 1,
                    customerId: customerId,
                    companyCode: '',
                    userType: this.activeUserType || 'ENTERPRISE_ROOT'
                };
            } else {
                this.dioForm = {
                    username: '',
                    account: '',
                    mobile: '',
                    email: '',
                    status: 1,
                    customerId: '',
                    companyCode: '',
                    userType: this.activeUserType || 'ENTERPRISE_ROOT'
                };
            }
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.clearValidate();
            });
        },
        async validateCompanyCode() {
            // 企业创建时验证 Company ID 是否存在
            if (!this.dioForm.companyCode) return false;
            try {
                const res = await checkCompany(this.dioForm.companyCode);
                if (res && res.state && res.state.code === 200) {
                    return true;
                }
                this.$message.error(this.$t('account_redesign.company_id_not_exist'));
                return false;
            } catch (e) {
                this.$message.error(this.$t('account_redesign.company_id_not_exist'));
                return false;
            }
        },
        async checkCompanyUnique() {
            // 企业编辑时校验：一个 Company 只能有一个初始账号
            if (this.isPersonal || !this.isEdit) return true;
            if (!this.dioForm.customerId) return false;
            try {
                const { result } = await accountList({
                    customerId: this.dioForm.customerId,
                    userType: 'ENTERPRISE_ROOT',
                    iDisplayStart: 0,
                    iDisplayLength: 10
                });
                const existing = result || [];
                const others = existing.filter(item => item.id !== this.dioForm.id);
                if (others.length > 0) {
                    this.$message.error(this.$t('account_redesign.company_already_has_root'));
                    return false;
                }
            } catch (e) {
                console.error('checkCompanyUnique error:', e);
            }
            return true;
        },
        async handleSave() {
            try {
                await this.$refs.form.validate();
            } catch (e) {
                return;
            }
            // 企业创建：验证 Company ID
            if (!this.isPersonal && !this.isEdit) {
                const valid = await this.validateCompanyCode();
                if (!valid) return;
            }
            // 企业编辑：校验 Company 唯一性
            if (!this.isPersonal && this.isEdit) {
                const unique = await this.checkCompanyUnique();
                if (!unique) return;
            }
            this.submitLoading = true;
            try {
                if (this.isEdit) {
                    // 编辑流程：使用新的 updateAccountProfile API（不涉及角色/范围，避免 409）
                    // 注意：WebLoginCtroller 有 @SnakeCaseResponse，WebAuthLogic 过滤器会在请求阶段
                    // 设置 SNAKE_CASE_FLAG，使反序列化使用 snakeToCamelMapper（期望 snake_case 输入）
                    const payload = {
                        userId: this.dioForm.id,
                        username: this.dioForm.username,
                        mobile: this.dioForm.mobile,
                        email: this.dioForm.email,
                        status: this.dioForm.status
                    };
                    // Enterprise 编辑时可变更所属 Company
                    if (!this.isPersonal && this.dioForm.customerId) {
                        payload.customerId = this.dioForm.customerId;
                    }
                    const res = await updateAccountProfile(payload);
                    if (res && res.state && res.state.code === 200) {
                        // 编辑成功：不触发邀请浮动框，直接关闭并刷新列表
                        this.isShowDialog = false;
                        this.$message.success(this.$t('user.user_new_code_200'));
                        this.$parent.getListFn();
                    } else {
                        const msg = (res && res.state && res.state.msg) || this.$t('account_redesign.operate_failed');
                        this.$message.error(msg);
                    }
                } else {
                    // 创建流程：使用新 API（含邀请记录、初始密码）
                    const api = this.isPersonal ? createPersonalAccount : createEnterpriseRootAccount;
                    const res = await api(this.dioForm);
                    if (res && res.state && res.state.code === 200) {
                        const result = res.result || {};
                        // 不关闭父弹窗，等成功弹窗关闭时再关（避免父弹窗关闭导致成功弹窗消失）
                        // 兼容 snake_case（后端 @SnakeCaseResponse 返回 initial_password）
                        this.createdPassword = result.initialPassword || '';
                        this.createdAccount = result.username || this.dioForm.account;
                        this.createdCompanyCode = this.dioForm.companyCode || '';
                        this.passwordVisible = false;
                        this.showSuccessDialog = true;
                        this.$parent.getListFn();
                    } else {
                        const msg = (res && res.state && res.state.msg) || this.$t('account_redesign.operate_failed');
                        this.$message.error(msg);
                    }
                }
            } catch (e) {
                console.error('AccountFormDialog save error:', e);
                const msg = (e && e.response && e.response.data && e.response.data.state && e.response.data.state.msg)
                    || (e && e.state && e.state.msg)
                    || this.$t('account_redesign.operate_failed');
                this.$message.error(msg);
            } finally {
                this.submitLoading = false;
            }
        },
        togglePassword() {
            this.passwordVisible = !this.passwordVisible;
        },
        closeSuccessDialog() {
            this.showSuccessDialog = false;
            this.createdPassword = '';
            this.createdAccount = '';
            this.createdCompanyCode = '';
            this.passwordVisible = false;
            // 关闭成功弹窗时同时关闭父弹窗
            this.isShowDialog = false;
        },
        downloadCsv() {
            let loginUrl = window.location.origin + '/login';
            // 企业初始账号：登录 URL 带 mode=root 参数（不需要 companyCode）
            if (!this.isPersonal && this.createdCompanyCode) {
                loginUrl += '?mode=root';
            }
            // 个人账号：登录 URL 不带参数
            const header = `${this.$t('account_redesign.csv_username')},${this.$t('account_redesign.csv_password')},${this.$t('account_redesign.csv_login_url')}`;
            const row = `${this.createdAccount},${this.createdPassword},${loginUrl}`;
            const csvContent = header + '\n' + row;
            const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            const prefix = this.isPersonal ? 'personal_account' : 'enterprise_root_account';
            link.download = `${prefix}_${this.createdAccount}.csv`;
            link.click();
            URL.revokeObjectURL(link.href);
        }
    }
};
</script>

<style scoped>
.success-dialog-body {
    line-height: 1.8;
}
.success-dialog-body .success-body-text {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 12px;
}
.success-dialog-body .success-warning-text {
    color: #e6a23c;
    font-weight: bold;
    margin-bottom: 12px;
}
.success-dialog-body .success-choose-text {
    margin-bottom: 8px;
}
.success-dialog-body .success-desc-text {
    color: #606266;
    margin-bottom: 4px;
}
.success-dialog-body .password-display {
    margin: 16px 0;
    padding: 10px 16px;
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    border-radius: 4px;
}
.success-dialog-body .password-display .password-label {
    font-weight: bold;
}
.success-dialog-body .password-display .password-value {
    font-family: monospace;
    font-size: 16px;
    color: var(--primary-color);
}
.success-dialog-body .success-security-text {
    color: #909399;
    font-size: 13px;
    margin-top: 12px;
}
</style>
